import { TYPE_COLLECTION } from './input-types';
import { SHIPPING_ACCOUNT } from '../constants';

export const id = SHIPPING_ACCOUNT;
export const apiKey = 'ShippingAccount';
export const type = TYPE_COLLECTION;

export const shippingAccount = {
  id,
  apiKey,
  type,
};
